import React, { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import Skeleton from 'app/shared/components/common/Skeleton/Skeleton';
import withLoading, { WithLoadingPropTypes } from 'hocs/withLoading';
import PropTypes from 'prop-types';
import { compose } from 'redux';

import { SKELETON_TYPES } from 'constants/skeleton';
import { useEffectSafeStrictMode } from 'hooks/useEffectSafeStrictMode';

import { getTaskSlaGroupAction } from 'store/loanApplications/actions';
import { selectTaskSlaGroupLevelsData } from 'store/loanApplications/selectors';

import { columns } from './TaskSlaGroupInfoTable.constants';
import { TaskSlaGroupInfoTableTestIds } from './TaskSlaGroupInfoTable.testIds';
import SlaGroupInfoTableItem from './TaskSlaGroupInfoTableItem';

const TaskSlaGroupInfoTable = ({ slaGroupId, isLoading, setIsLoading }) => {
  const dispatch = useDispatch();
  const slaGroupData = useSelector(selectTaskSlaGroupLevelsData(slaGroupId));

  useEffectSafeStrictMode(() => {
    setIsLoading(true);
    dispatch(getTaskSlaGroupAction({ taskSlaGroupId: slaGroupId }))
      .catch(Error)
      .finally(() => setIsLoading(false));
  }, [dispatch, setIsLoading, slaGroupId]);

  if (isLoading) {
    return (
      <Skeleton cellsNumber={columns.length} length={2} type={SKELETON_TYPES.TABLE} width={1200} />
    );
  }

  return (
    <Table
      stickyHeader
      className="table-fixed"
      data-testid={TaskSlaGroupInfoTableTestIds.TASK_SLA_GROUP_TABLE}
    >
      <TableHead>
        <TableRow className="h-64 uppercase">
          {columns.map(({ align, id, label, className }) => (
            <TableCell align={align} className={className} key={id}>
              {label}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {slaGroupData.map(level => (
          <SlaGroupInfoTableItem key={level.id} level={level} />
        ))}
      </TableBody>
    </Table>
  );
};

TaskSlaGroupInfoTable.propTypes = {
  ...WithLoadingPropTypes,
  slaGroupId: PropTypes.string.isRequired,
};

export default compose(withLoading, memo)(TaskSlaGroupInfoTable);
